<template>
  <div class="v4-card">
    <!-- Refresh overlay -->
    <div v-if="refresh && timeserchtype==='...'" @click="Refrechdata(action)" class="vld-overlay-refrech">
      <div class="vld-background" style="backdrop-filter: blur(2px);"></div>
      <button class="btnn box flex items-center text-gray-700 cursor-not-allowed pointer-events-none">
        <img class="analytics-imgg" src="https://img.icons8.com/office/80/000000/refresh--v1.png"/> Refresh
      </button>
    </div>

    <!-- Blue header -->
    <div class="v4-hero">
      <div class="v4-hero-top">
        <div>
          <h3 class="v4-hero-title">{{statSubtitle}}</h3>
          <p class="v4-hero-subtitle">Overview {{ new Date().getFullYear() }}</p>
        </div>
        <select v-if="filter" :name="action" @change="ChangeDateConfirmation($event)" v-model="timeserchtype" class="v4-hero-select">
          <option value="all">All</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="thisweek">This week</option>
          <option value="lastweek">Last week</option>
          <option value="thismonth">This Month</option>
          <option value="lastmonth">Last Month</option>
          <option value="thisyear">This Year</option>
          <option value="betweendate">Between date</option>
        </select>
      </div>

      <!-- Filters -->
      <div v-if="filterseller && currentUser && currentUser.type && currentUser.role && currentUser.role.name" class="v4-filters">
        <div class="v4-filter-row">
          <div class="v4-filter-item" v-if="currentUser.role.name!='Seller' && currentUser.type!='Seller'">
            <v-select @search="getUsersDebance($event,'shipsen')" @input="CheckSellerProducts($event,action,'seller')" label="fullName" placeholder="Seller" :options="sellers" v-model="sellerdata" class="v4-filter-select"></v-select>
          </div>
          <div class="v4-filter-item">
            <v-select @search="getProducts($event,'shipsen')" @input="CheckSellerProducts($event,action,'product')" label="name" placeholder="Product" :options="products" v-model="productdata" class="v4-filter-select"></v-select>
          </div>
          <button class="v4-filter-clear" @click="removedata(action)">
            <i class="material-icons" style="font-size:16px">close</i>
          </button>
        </div>
        <div v-if="filter && timeserchtype=='betweendate'" class="v4-filter-date">
          <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="v4-datepicker" v-model="fromDate" range></date-picker>
          <button @click="FindRecordsBetweenDate()" :class="!fromDate?'noselect':''" :disabled="!fromDate" class="v4-filter-search">
            <i class="material-icons" style="font-size:18px">search</i>
          </button>
        </div>
      </div>
    </div>

    <!-- Status list -->
    <div class="v4-list relative">
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <div v-if="dataChart" class="v4-items">
        <div v-for="(item, index) in dataChart" :key="index" class="v4-item">
          <div class="v4-item-top">
            <div class="v4-item-info">
              <span class="v4-item-name">{{item.name=='Unreached'?'Pending Unreached':item.name}}</span>
              <span class="v4-item-count">{{item.count}}</span>
            </div>
            <span class="v4-item-percent" :style="'background:'+item.colors+'20; color:'+item.colors">{{item.percent}}%</span>
          </div>
          <div class="v4-progress">
            <div class="v4-progress-bar" :style="'width:'+item.percent+'%; background:'+item.colors"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "card-stats-v4",
  props: {
    statSubtitle: {
      default: "Traffic",
    },
    loading:{required:false},
    timeserch:{},
    titleRate:{},
    from:{},
    to:{},
    filter: {
      default: false,
    },
    statTitle: {},
    action: {},
    statArrow: {
      default: "up",
      validator: function (value) {
        // The value must match one of these strings
        return ["up", "down"].indexOf(value) !== -1;
      },
    },
    statPercent: {},
    // can be any of the text color utilities
    // from tailwindcss
    statPercentColor: {
      default: "text-green-500",
    },
    statDescripiron: {},
    id:{type:String},
    color:{type:String},
    currency: {default:false},
    count:{type: Number,default:0},
    datas:{type:Object},
    dataChart:{type:Array},
    countText:{},
    refresh: {
      default: false,
    },
    rate:{},
    statIconName: {
      default: "far fa-chart-bar",
    },
    // can be any of the background color utilities
    // from tailwindcss
    statIconColor: {
      type: String,
      default: "bg-red-500",
    },
    seller:{},
   product:{},
   sellers:{type:Array},
   products:{type:Array},
   currentUser:{type:Object},
    filterseller: {
      default: false,
    },
  },
  data() {
    return {
      fullPage: false,
      myChart: "lll",
      myChartALL: ["","","","",""],
      timeserchtype:this.timeserch,
      fromDate:this.from,
      toDate:this.to,
      sellerdata:this.seller,
      productdata:this.product,
    };
  },
  watch: {
    'timeserch': function () {
      this.timeserchtype=this.timeserch;
    },
    'seller': function () {
      this.sellerdata=this.seller;
   },
   'product': function () {
      this.productdata=this.product;
   },
    dataChart: function () {
      if (this.myChartALL.length>0 && this.myChartALL[0]) {
        for (let i in this.myChartALL) {
              this.myChartALL[i].destroy();
        }
      }
      this.drawChart(this.dataChart);
      for (let i in this.myChartALL) {
          this.myChartALL[i].render();
        }
    },
  },
  async mounted(){
     await this.drawChart(this.dataChart);
     if (this.myChartALL.length>0 && this.myChartALL[0]) {
        for (let i in this.myChartALL) {
             this.myChartALL[i].render();
        }
     }
  },
   methods: {
    ChangeDateConfirmation: function (val) {
      this.$emit("ChangeDateConfirmation", val);
    },
    Refrechdata: function (val) { 
        this.$emit("Refrechdata", val);
    },
    ChangeDateCallcenter: function (val) {
         this.$emit("ChangeDateCallcenter", val);
    },
    FindRecordsBetweenDate: function (val) {
         this.$emit("FindRecordsBetweenDate", this.action,this.fromDate,this.toDate);
    },
      FindRecordsSellers: function (val) {
        this.$emit("FindRecordsSellers", this.action,this.sellerdata,this.productdata);
    },
    getUsersDebance: function (name) {
        this.$emit("getUsersDebance", name);
     }, 
    getProducts: function (name) {
        this.$emit("getProducts", name);
     }, 
    async CheckSellerProducts(seller,action,model){
       this.$emit("CheckSellerProducts", seller,action,model);
    },
    removedata: function (val) {
        this.$emit("removedata", this.action);
     }, 
    drawChart(chartData) {
        for (let i in chartData) {
            this.myChartALL[i] = new ApexCharts(document.getElementById((chartData[i].name).toLowerCase()), {
              chart: {
                height: 110,
                width:90,
                type: 'radialBar',
                toolbar: {
                  show: false
                }
              },
              plotOptions: {
                radialBar: {
                  //startAngle: -135,
                  //endAngle: 225,
                  hollow: {
                    margin: 0,
                    size: '70%',
                    background: '#fff',
                    image: undefined,
                    imageOffsetX: 0,
                    imageOffsetY: 0,
                    position: 'front',
                    dropShadow: {
                      enabled: true,
                      top: 3,
                      left: 0,
                      blur: 4,
                      opacity: 0.24
                    }
                  },
                  track: {
                    background: '#fff',
                    strokeWidth: '67%',
                    margin: 0, // margin is in pixels
                    dropShadow: {
                      enabled: true,
                      top: -3,
                      left: 0,
                      blur: 4,
                      opacity: 0.35
                    }
                  },
                  dataLabels: {
                    showOn: 'always',
                    name: {
                      offsetY: -0,
                      show: false,
                      color: 'rgba(0, 0, 0, 0.84)',
                      fontSize: '16px'
                    },
                    value: {
                      formatter: function (val) {
                        return val + "%";
                      },
                      offsetY: 8,
                      color: 'rgba(0, 0, 0, 0.84)',
                      fontSize: '19px',
                      show: true,
                    }
                  }
                }
              },
              fill: {
                type: 'gradient',
                gradient: {
                  shade: 'light',
                  type: 'horizontal',
                  shadeIntensity: 0.5,
                  gradientToColors: [chartData[i].gradient],
                  inverseColors: false,
                  opacityFrom: 1,
                  opacityTo: 1,
                  stops: [0, 100]
                }
              },
              colors: [chartData[i].colors],
              series: [chartData[i].percent],
              stroke: {
                lineCap: 'round'
              },
              labels: ['Percent'],
              responsive: [{
                breakpoint: 480,
                options: {
                  chart: {
                    height: 230
                  }
                }
              }]
            });
      }
       
    },
   }
};
</script>
<style scoped>
/* V4 Card */
.v4-card {
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  transition: all 0.3s ease;
}
.v4-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* Blue hero header */
.v4-hero {
  background: linear-gradient(135deg, #4285f4 0%, #5b9bf4 100%);
  padding: 24px;
  color: #ffffff;
}
.v4-hero-top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.v4-hero-title {
  font-size: 20px;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
}
.v4-hero-subtitle {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  margin: 4px 0 0;
}
.v4-hero-select {
  appearance: auto;
  font-size: 12px;
  font-weight: 500;
  color: #475569;
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;
  outline: none;
}

/* Filters on hero */
.v4-filters {
  background: rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  padding: 8px;
  margin-top: 16px;
}
.v4-filter-row {
  display: flex;
  align-items: center;
  gap: 6px;
}
.v4-filter-item {
  flex: 1;
  min-width: 0;
}
.v4-filter-select {
  font-size: 12px !important;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
}
.v4-filter-clear {
  width: 30px;
  height: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
}
.v4-filter-clear:hover {
  background: rgba(255, 255, 255, 0.35);
}
.v4-filter-date {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
}
.v4-datepicker {
  flex: 1;
}
.v4-filter-search {
  width: 34px;
  height: 34px;
  min-width: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: none;
  background: rgba(255, 255, 255, 0.25);
  color: #ffffff;
  cursor: pointer;
}
.v4-filter-search:hover {
  background: rgba(255, 255, 255, 0.4);
}

/* Status list */
.v4-list {
  padding: 8px 20px 16px;
  flex: 1;
}
.v4-items {
  display: flex;
  flex-direction: column;
}
.v4-item {
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}
.v4-item:last-child {
  border-bottom: none;
}
.v4-item-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}
.v4-item-info {
  display: flex;
  flex-direction: column;
}
.v4-item-name {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  text-transform: capitalize;
}
.v4-item-count {
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}
.v4-item-percent {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
}

/* Progress bar */
.v4-progress {
  width: 100%;
  height: 4px;
  background: #f1f5f9;
  border-radius: 2px;
  overflow: hidden;
}
.v4-progress-bar {
  height: 100%;
  border-radius: 2px;
  transition: width 0.5s ease;
}
</style>
